import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { assets } from "../../data/sep26Data";
import { EASE_OUT } from "./hooks";

// Pestañas que se abren al pasar el mouse y se unen al marco de la foto
// con esquinas cóncavas; la foto cambia con un fundido.
const TABS = [
  {
    title: "La plantilla",
    text: "Catorce jugadores, portero y cuerpo técnico, ya con el traje nuevo.",
    src: assets.teamB,
    alt: "Plantilla de Arsenal de Allende con el traje de la temporada, en la cancha azul",
  },
  {
    title: "La familia",
    text: "En la foto también están los más chicos de la casa.",
    src: assets.teamA,
    alt: "Plantilla de Arsenal de Allende en la cancha azul, de noche, con familiares",
  },
  {
    title: "El traje",
    text: "Azul profundo, oro y el escudo de Allende al pecho.",
    src: "/temporada-sep26/traje-poster.jpg",
    alt: "Traje de la temporada en una vitrina",
  },
  {
    title: "La cancha",
    text: "Canchas Colonias del Norte. El horario se sortea cada semana, entre 7 y 11 pm.",
    src: assets.cancha,
    alt: "Cancha de pasto azul bajo las luces, de noche",
  },
];

export const Galeria26 = () => {
  const [active, setActive] = useState(0);
  const refs = useRef([]);

  const onKeyDown = (e, i) => {
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    e.preventDefault();
    const next = (i + (e.key === "ArrowDown" ? 1 : TABS.length - 1)) % TABS.length;
    setActive(next);
    refs.current[next]?.focus();
  };

  return (
    <section id="galeria" data-testid="s26-galeria" className="section-pad">
      <div className="wrap">
        <motion.h2
          className="display mb-10 text-[clamp(44px,8vw,112px)]"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE_OUT }}
        >
          El equipo, <span style={{ color: "var(--gold)" }}>de cerca</span>
        </motion.h2>

        <motion.div
          className="ht-panel"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE_OUT }}
        >
          <div className="ht-list" role="tablist" aria-label="Galería del equipo" aria-orientation="vertical">
            {TABS.map((t, i) => (
              <button
                key={t.title}
                ref={(el) => (refs.current[i] = el)}
                type="button"
                role="tab"
                id={`ht-tab-${i}`}
                aria-selected={active === i}
                aria-controls="ht-panel"
                tabIndex={active === i ? 0 : -1}
                className="ht-tab"
                data-testid={`s26-galeria-tab-${i + 1}`}
                onPointerEnter={(e) => e.pointerType === "mouse" && setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                onKeyDown={(e) => onKeyDown(e, i)}
              >
                <span className="ht-title">{t.title}</span>
                <span className="ht-desc">
                  <span>{t.text}</span>
                </span>
              </button>
            ))}
          </div>

          <div className="ht-frame" id="ht-panel" role="tabpanel" aria-labelledby={`ht-tab-${active}`}>
            <div className="ht-pic">
              {TABS.map((t, i) => (
                <img
                  key={t.src}
                  src={t.src}
                  alt={active === i ? t.alt : ""}
                  aria-hidden={active !== i}
                  className="ht-img"
                  data-active={active === i}
                  loading={i < 2 ? "eager" : "lazy"}
                  draggable="false"
                />
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
